import { shouldForwardProp as baseShouldForwardProp } from '@mui/system'

/**
  This function customizes the prop forwarding behavior in MUI styled components
  by excluding a specific set of custom properties from being forwarded to the DOM,
  while still respecting the base forwarding rules defined by MUI.
*/
export const shouldForwardProp = (prop: PropertyKey) => {
  const ignoredProps: PropertyKey[] = [
    'active',
    'bold',
    'copied',
    'fill',
    'fullWidth',
    'hasBorder',
    'hasError',
    'hasSuccess',
    'hasWarning',
    'indeterminate',
    'loading',
    'open',
    'requiredError',
    'error',
    'hasInfo',
    'hasWarning',
    'successoutline',
    'textuppercase',
    'iconColor'
  ]

  return baseShouldForwardProp(prop) && !ignoredProps.includes(prop)
}
